import { API_ROUTES } from "../../utils/constants";
import { AxiosBase } from "./index";

export default class UserRoleService extends AxiosBase {
  getRolesData = async ({
    page,
    limit,
    searchQuery,
    sortKey,
    sortDirection,
    navigate,
  }) => {
    try {
      const response = await this.requests.get(
        `${
          API_ROUTES.USER_ROLES.GET_ROLES
        }?page=${page}&limit=${limit}&searchQuery=${encodeURIComponent(
          searchQuery
        )}&sortKey=${sortKey}&sortDirection=${sortDirection}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  addNewRole = async (body, navigate) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.USER_ROLES.ADD_ROLE}`,
        body
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  editRole = async ({ body, id, page, limit, navigate }) => {
    try {
      const response = await this.requests.put(
        `${API_ROUTES.USER_ROLES.EDIT_ROLE}/${id}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  deleteRoles = async ({ body }) => {
    try {
      const response = await this.requests.delete(
        `${API_ROUTES.USER_ROLES.DELETE_ROLES}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  getRoleUsersById = async (id, navigate) => {
    try {
      const url = `${API_ROUTES.USER_ROLES.GET_USERS}?roleId=${id}`;
      const response = await this.requests.get(url);
      return response;
    } catch (err) {
      throw err;
    }
  };
}
